import {metadaApi} from '@dms/api/base';

import {
  GetArticleUpdateJobRequest,
  GetArticleUpdateJobResponse,
  GetArticleUpdateJobRequestSchema,
  GetArticleUpdateJobResponseSchema,
  PatchArticleUpdateJobResponse,
  PatchArticleUpdateJobRequest,
  PatchArticleUpdateJobRequestSchema,
  PatchArticleUpdateJobResponseSchema,
  PostArticleUpdateJobResponse,
  PostArticleUpdateJobRequest,
  PostArticleUpdateJobRequestSchema,
  PostArticleUpdateJobResponseSchema,
  DeleteArticleUpdateJobRequest,
  DeleteArticleUpdateJobResponse,
  DeleteArticleUpdateJobRequestSchema,
  DeleteArticleUpdateJobResponseSchema,
} from './types';

export const metadaWarehouseArticleUpdateJobApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getArticleUpdateJob: build.query<GetArticleUpdateJobResponse, GetArticleUpdateJobRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/article-update-job/${queryArg.articleUpdateJobId}`,
        method: 'GET',
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'articleUpdateJobs', id: queryArg.articleUpdateJobId},
      ],
      extraOptions: {
        requestSchema: GetArticleUpdateJobRequestSchema,
        responseSchema: GetArticleUpdateJobResponseSchema,
      },
    }),
    postArticleUpdateJob: build.mutation<PostArticleUpdateJobResponse, PostArticleUpdateJobRequest>(
      {
        query: (queryArg) => ({
          url: 'warehouse/v1/article-update-job/user',
          method: 'POST',
          body: queryArg,
          queryArg,
        }),
        invalidatesTags: (result) => [{type: 'articleUpdateJobs', id: result?.articleUpdateJobId}],
        extraOptions: {
          requestSchema: PostArticleUpdateJobRequestSchema,
          responseSchema: PostArticleUpdateJobResponseSchema,
        },
      }
    ),
    patchArticleUpdateJob: build.mutation<
      PatchArticleUpdateJobResponse,
      PatchArticleUpdateJobRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/article-update-job/${queryArg.articleUpdateJobId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'articleUpdateJobs', id: queryArg.articleUpdateJobId},
      ],
      extraOptions: {
        requestSchema: PatchArticleUpdateJobRequestSchema,
        responseSchema: PatchArticleUpdateJobResponseSchema,
      },
    }),
    deleteArticleUpdateJob: build.mutation<
      DeleteArticleUpdateJobResponse,
      DeleteArticleUpdateJobRequest
    >({
      query: (queryArg) => ({
        url: 'warehouse/v1/article-update-job/delete',
        method: 'POST',
        body: queryArg,
        queryArg,
      }),
      extraOptions: {
        requestSchema: DeleteArticleUpdateJobRequestSchema,
        responseSchema: DeleteArticleUpdateJobResponseSchema,
      },
    }),
  }),
});

export const {
  useGetArticleUpdateJobQuery,
  usePostArticleUpdateJobMutation,
  usePatchArticleUpdateJobMutation,
  useDeleteArticleUpdateJobMutation,
} = metadaWarehouseArticleUpdateJobApi;
